import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { SessionService } from '../services/session.service';

// Route guard for the super-admin console. session.user.roles is populated by the
// APP_INITIALIZER (settingsFactory) before any route activates, so this is reliable on
// a hard refresh straight to /admin/users. While impersonating, roles become the target's
// (no 'superadmin'), so the console is correctly blocked until the admin returns.
@Injectable({ providedIn: 'root' })
export class SuperAdminGuard {
  constructor(private router: Router, private session: SessionService) {}

  canActivate(): boolean | UrlTree {
    if (this.session.user?.roles?.includes('superadmin')) {
      return true;
    }
    return this.router.parseUrl('/dashboard');
  }
}
